export function setAppVariable(params) {
  const {
    appId,
    version
  } = params;
  if (window.APP_ROOT_TPL) {
    window.APP_ID = appId;
    window.APP_ROOT = window.APP_ROOT_TPL.replace("{id}", appId).replace("{version}", version);
  }
}
//# sourceMappingURL=setAppVariable.js.map